<template>
    <div class="container">
        <content-header title="Ультразвуковые исследования"/>
        <p style="font-size: 16px;">• <b>Подготовка к УЗИ органов брюшной полости</b></p>
        <div style="margin-left: 1em;">
            <p style="font-size: 16px;">За 3 дня до исследования необходимо исключить из рациона продукты, усиливающие
                газообразование в кишечнике: сырые овощи и фрукты, черный хлеб, цельное молоко, бобовые, газированные
                напитки, квашеную капусту, квас.</p>
            <p style="font-size: 16px;">Принимать в течение 2-3 дней активированный уголь (по 2 таблетки 3 раза в день)
                или «Эспумизан» по схеме, прилагаемой к упаковке препарата.</p>
            <p style="font-size: 16px;">УЗИ проводится строго натощак, поэтому необходимо воздержаться от приема пищи в
                течение 8-12 часов до исследования. Если исследование проводится во второй половине дня, допускается
                легкий завтрак.</p>
            <p style="font-size: 16px;">Если Вы принимаете лекарственные средства, предупредите об этом врача —
                диагноста.</p>
        </div>
        <hr>
        <p style="font-size: 16px;">• <b>Подготовка к УЗИ органов малого таза</b></p>
        <div style="margin-left: 1em;">
            <p style="font-size: 16px;">Трансабдоминальное (через живот) исследование проводится при полном мочевом
                пузыре, поэтому необходимо не мочиться до исследования в течение 3-4 часов и выпить 1л негазированной
                жидкости (чай, морс, вода) за 1-1,5 часа до процедуры. При невозможности терпеть и сильном позыве,
                допустимо немного опорожнить пузырь для снятия напряжении и повторно выпить немного жидкости для
                достижения полного наполнения мочевого пузыря к моменту исследования.</p>
            <p style="font-size: 16px;">Подготовка к трансвагинальному исследованию органов малого таза у женщин:
                исследование проводится на пустой мочевой пузырь, на 5 – 7 день менструального цикла (от первого дня
                месячных), если нет дополнительных указаний врача, так как в ряде случаев УЗИ проводится в середине
                цикла или перед месячными.</p>
        </div>
        <hr>
        <p style="font-size: 16px;">• <b>Подготовка к трансректальному исследованию простаты</b></p>
        <div style="margin-left: 1em;">
            <p style="font-size: 16px;">Накануне исследования необходимо сделать очистительную клизму — 1,5 литра.</p>
            <p style="font-size: 16px;">Утром, при необходимости, опорожнить кишечник.</p>
            <p style="font-size: 16px;">Перед исследованием опорожнить мочевой пузырь.</p>
            <p style="font-size: 16px;">Обследование проводится не натощак, поэтому можно есть и пить в день проведения
                процедуры.</p>
        </div>
        <hr>
        <p style="font-size: 16px;">• <b>Подготовка к УЗИ почек</b></p>
        <div style="margin-left: 1em;">
            <p style="font-size: 16px;">При исследовании почек специальной подготовки не требуется, но при наличии у
                пациента избыточного веса и повышенном газообразовании в кишечнике готовиться нужно, как к УЗИ органов
                брюшной полости.</p>
        </div>
        <hr>
        <p style="font-size: 16px;">• <b>Подготовка к УЗИ молочных желез</b></p>
        <div style="margin-left: 1em;">
            <p style="font-size: 16px;">Исследование молочных желез желательно проводить во время первых 10 дней
                менструального цикла.</p>
        </div>
        <hr>
        <p style="font-size: 16px;">• <b>Подготовка к УЗИ глаза и орбиты</b></p>
        <div style="margin-left: 1em;">
            <p style="font-size: 16px;">Рекомендуется заранее смыть макияж или не наносить его в день исследования.</p>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "Ультразвуковые исследования",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>
